import { Alert, Card, CardContent, CardHeader, Divider, Stack, Typography } from "@mui/material"
import { Movimentacao } from "../../mov.model"
import { formatData,getDataAmerica } from "../../../../services/utils"


export const CardCanalDist = ({ mov }: { mov: Movimentacao }) => {

    if (mov.canal_dist?._id === undefined)
        return null

    return (

        <Card >
            <CardHeader disableTypography title={<Typography variant="subtitle1" >Entrega</Typography>} />
            <CardContent>
                <Typography>{mov.canal_dist.funcionario.nome}</Typography>
                <Typography>{mov.canal_dist.funcionario.whatsapp}</Typography>
                <Divider />
                { getDataAmerica(mov.canal_dist.data) === getDataAmerica(mov.created_at)?(
                    <Typography>{formatData(mov.canal_dist.data)}</Typography>
                ):(
                    <Stack flexDirection={"row"} flexWrap={"wrap"}>
                        <Alert color="error" severity="error">
                            <Typography color="error">{formatData(mov.canal_dist.data)}</Typography>
                            <Typography>(Informe o canal de distribuição com a mesma data!)</Typography>
                        </Alert>
                    </Stack>
                )}
                
            </CardContent>
        </Card>

    )
}